module.exports = __webpack_public_path__ + "static/img/moreFunction1.b09be3f.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/moreFunction1.webp
// module id = XIzX
// module chunks = 1